// partially copied from Trello modified to use confluences network check

export const getInternetConnectionState = async (): Promise<'healthy' | 'unhealthy'> => {
	// we can early return unhealthy if offline for navigator, but we cant if onLine.
	// That's because you can be online, but be waiting for VPN connection or something
	// else that blocks actually allowing internet.
	if (!navigator.onLine) {
		return 'unhealthy';
	}

	for (let i = 0; i < 3; i++) {
		if (!navigator.onLine) {
			return 'unhealthy';
		}

		// stagger it a little because of flakey VPN's and firewalls
		await new Promise((res) => setTimeout(res, 1000));
	}

	// we got 3 good attempts, safe to say healthy
	return 'healthy';
};
